import { useEffect, useState } from 'react';
import { Box, Button, Card, Grid, IconButton, Menu, MenuItem, TextField, Typography } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import CustomToolbar from '../../../components/Tools/CustomeToolbar';
import moment from 'moment';

import DateInput from '../../../components/Form/DateInput';
import { useForm } from 'react-hook-form';
import StatusSelector from '../../../components/Form/Status';
import PageHeader from '../../../components/PageHeader/PageHeader';
import AssignTo from '../../../components/Form/AssignTo';
import useAssignees from '../../../components/CommonFunctions/Usres';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import Delete from '../../../components/Popup/Delete';
import { FollowUps } from '../../../api/Endpoints/FollowUps';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { Waveform } from '@uiball/loaders';
import Create from './create';
import { GlobalRefreshContext } from '../../../contexts/GlobalRefresh/GlobalRefresh';
import StatusLIstFunction from '../../../components/CommonFunctions/statusLIst';
import View from './view'
import { WhatsappTemplatesAPI } from '../../../api/Endpoints/WhatsappTemplateAPI';
import { vi } from 'date-fns/locale';


export default function WhatsappTemplates() {

    const columns = [
        {
            field: 'title',
            headerName: 'Title',
            width: 500,
            renderCell: (params) => (
                <Typography
                    size="small"
                    sx={{ cursor: 'pointer', whiteSpace: 'break-spaces' }}
                    onClick={() => viewPopup(params)}
                    
                >
                    {params.row.name}
                </Typography>
            ),
        },
        {
            field: 'approval',
            headerName: 'Approval',
            width: 200,
            renderCell: (params) => <p>{params?.row?.status}</p>,
        },
        // {
        //     field: 'created_by',
        //     headerName: 'Created By',
        //     width: 200,
        //     renderCell: (params) => (params.row.created_by)
        // },


        // {
        //     field: 'created_at',
        //     headerName: 'Created Date',
        //     width: 200,
        //     renderCell: (params) => {
        //         const formattedDate = moment(params.value).format('DD-MM-YYYY');
        //         return <Typography style={{ color: '#6f6f6f' }}>{formattedDate}</Typography>;
        //     },
        // },
        // {
        //     field: '',
        //     width: 100,
        //     renderCell: (params) => (
        //         <IconButton color="primary" onClick={() => handleEdit(params.row.id)}>
        //             <EditIcon />
        //         </IconButton>
        //     ),
        // },
    ];

    const rows = [
        { id: 1, title: 'Project Alpha', name: 'Alpha', approval: 'Approved', created_by: 'jhon', created_at: '2024-02-21' },
        { id: 2, title: 'Project Beta', name: 'Beta', approval: 'Pending', created_by: 'jhone', created_at: '2024-02-19' },
        { id: 3, title: 'Project Gamma', name: 'Gamma', approval: 'Rejected', created_by: 'jhon', created_at: '2024-02-16' },
    ];

    const { watch, formState: { errors }, control, Controller, setValue, reset } = useForm({})



    const [loading, setLoading] = useState(false);
    const [leads, setLeads] = useState([])
    const [ViewID, setViewID] = useState(0)
    const [refresh, setRefresh] = useState(0)
    const { assignees, isLoading, fetchAssignees } = useAssignees();
    const [Modal, setModal] = useState(false);
    const [editId, setEditId] = useState(undefined);
    const [DeleteID, setDeleteID] = useState(0)
    const [serachEntry, setSearchEntry] = useState('')
    const { GlobalRefresh } = GlobalRefreshContext();
    const [selectedRow, setSelectedRow] = useState([])
 const [Showview,setShowView]=useState(false)
    const [showClosePopup, setShowClosePopup] = useState(false)
    const [CloseID, setCloseID] = useState(0)
    const [paginationModel, setPaginationModel] = useState({
        pageSize: 15,
        page: 0,
    });


    const leadTypeData = JSON.parse(sessionStorage.getItem('Lead_type'));
    const projectData = JSON.parse(sessionStorage.getItem('project'));




    useEffect(() => {
        fetchTemplates();
    }, [paginationModel, GlobalRefresh]);

    const fetchTemplates = async () => {
        try {
            setLoading(true);
            const response = await WhatsappTemplatesAPI.getTemplateList({
                page: parseInt(paginationModel?.page) + 1,
                crm_lead_type_id: leadTypeData?.ID,
                project_id: projectData.ID,
            });
            setLeads(response.data?.data);
            setLoading(false);
        } catch (error) {
            console.log(error.message);
            setLoading(false);
        }
    };




    // More option Funciton

    const handleEdit = (id) => { }
    const handleCreate = () => {
        setEditId(0)
        setRefresh(Math.random)
    }
    const handleUpdate = () => {
        setPaginationModel(0);
    }

    const viewTabs = (params) => {
        setViewID(params.id)
        setRefresh(Math.random)
    }


    const handleRowSelection = (newSelection) => {
        setSelectedRow(newSelection)
    };



    const handlePageChange = (page) => {
        setPaginationModel(page)
    }

const viewPopup=(params)=>{
    console.log(params
        
    );
    
setViewID(params?.row?.name)
}

    return (
        <div class="page-cntr">

{/* {ViewID && <View open={ViewID} setId={setViewID} id={ViewID}/>}
 */}

            <div class="lead-cntr follo-up-cntr " >



                <div class="lead-table  lead-page-cntr">
                    <div className="title-sec">
                        <Card sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}  >
                            <PageHeader title={'WhatsApp Templates'} total={!loading && leads?.data?.length} />

                            <Create
                                onNew={handleCreate}
                                onUpdate={handleUpdate}
                                editId={editId}
                                setEditId={setEditId} />
                        </Card>

                    </div>
                </div>

                <Card sx={{ display: 'flex', justifyContent: 'start' }}  >

                    {/* Props Passing  */}
                    {/* <View
                        from={selectedFromDate && selectedFromDate}
                        to={selectedToDate && selectedToDate}
                        viewID={ViewID}
                        setViewID={setViewID}
                        watch={watch}
                        control={control}
                        isDisable={true}
                        setFormValue={setValue}
                        statusList={statusList}
                        assignees={assignees} //Assignees list ,From AssignUser Api
                        func={fetchFollowUpsForTableUpdate} searchIsEnabled={serachEntry && true} //Fetch leads funcion to Update the Dom
                    /> */}






                    {Modal &&
                        <Create
                            key={refresh}
                            onNew={handleCreate}
                            onUpdate={handleUpdate}
                            editId={editId}
                            setEditId={setEditId}
                            setModal={setModal}
                            disableCtnBtn={true} />}

                </Card >

                {
                    loading ? (
                        <Box sx={{ width: '100%', marginTop: 10, height: 20, display: 'flex', justifyContent: 'center' }}>

                            <Waveform
                                size={40}
                                lineWeight={3.5}
                                speed={1}
                                color="blue"
                            />
                        </Box>
                    ) : (
                        <>

                            {leads.data && leads.length === 0 ? (
                                <Typography variant="body1" sx={{ display: 'flex', justifyContent: 'cent' }}>Data not found.</Typography>
                            ) : (
                                <Card sx={{ m: 0 }} variant="outlined" class="lead-table followup-table">
                                    {typeof leads.data === "object" && (
                                        <DataGrid
                                            paginationMode="server"
                                            rows={leads?.data}
                                            paginationModel={paginationModel}
                                            columns={columns}
                                            rowCount={leads?.data.length}
                                            rowHeight={70}
                                            autoHeight={true}
                                            scrollbarSize={10}
                                            density="comfortable"
                                            onPaginationModelChange={handlePageChange}
                                            onRowSelectionModelChange={handleRowSelection}
                                            disableColumnMenu
                                            disableRowSelectionOnClick
                                            disableExtendRowFullWidth

                                        />
                                    )}
                                </Card>
                            )}

                        </>
                    )}
            </div >
        </div >

    )
};


